













































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import GlobalMixins from '../mixins';
import { IStatement, IShootoutStatement, IParty } from '../interfaces';
import StatementTitle from '@/components/StatementTitle.vue';
import { StemWijzerHTTP } from '@/main';

@Component({
	components: {
		StatementTitle
	}
})
export default class Statement extends GlobalMixins {
	openTab: 'parties' | 'moreInfo' | false = false
	openParties: string[] = []
	windowWidth: number = 0
	titleOpen: boolean = false
	disableChoicebuttons:  boolean = true

	get statement(): IStatement {
		return this.$store.getters.statement()
	}
	get informationTabText(): string {
		if (!this.statement.moreInfo) return ''

		return `<h1>${this.statement.moreInfo.title}</h1>${this.statement.moreInfo.text}`
	}
	get informationTabAriaText(): string {
		if (!this.statement.moreInfo) return ''

		return `${this.statement.moreInfo.title}. ${this.statement.accessibility.moreInfo?.text ? this.statement.accessibility.moreInfo.text : this.statement.moreInfo.text}`
	}
	get isShootoutStatement(): boolean {
		return this.$route.name === 'shootout-statement'
	}
	get shootoutParties(): false | IParty[] {
		if (!this.user.shootoutParties || this.user.shootoutParties.length !== 2) return false

		return (this.user.shootoutParties as [number, number])
			.map(partyId => {
				return this.parties.filter(party => {
					return (partyId === party.id)
				})[0]
			})
	}
	get shootoutPartiesTabText(): string {
		return (this.dictionary.shootoutStatement.tabs.parties.preParties ? (this.dictionary.shootoutStatement.tabs.parties.preParties + ' ') : '') + (this.shootoutParties as IParty[])[0].name + (this.dictionary.shootoutStatement.tabs.parties.preParties ? (' ' + this.dictionary.shootoutStatement.tabs.parties.betweenParties + ' ') : ' - ') + (this.shootoutParties as IParty[])[1].name + (this.dictionary.shootoutStatement.tabs.parties.afterParties ? (' ' + this.dictionary.shootoutStatement.tabs.parties.afterParties) : '')
	}

	@Watch('openTab')
	onOpenTabChange() {
		if (this.openTab !== 'parties') {
			this.openParties = []
		}
	}

	recordChoice(choice: 'agree' | 'neither' | 'disagree' | 'skip') {
		if (this.disableChoicebuttons) return

		this.disableChoicebuttons = true
		
		this.$store.dispatch('setStatementChoice', {
			choice,
			statement: JSON.parse(this.$route.params.id),
			originalStatementId: this.statement.id,
			shootout: this.isShootoutStatement
		})

		if (choice === 'skip' && !this.isShootoutStatement) {
			this.$store.dispatch('removeFromPriorityStatements', this.statement.id)
		}

		if ((!this.isShootoutStatement && (JSON.parse(this.$route.params.id) === this.statements.length)) || (this.isShootoutStatement && (JSON.parse(this.$route.params.id) === this.shootoutStatements.length))) {

			if (this.isShootoutStatement) {
				this.trackGAEvent('results-shootout-finished')
			}

			this.$router.push({name: (this.isShootoutStatement ? 'results' : 'select-statements')})
		} else {
			this.$router.push({
				name: (this.isShootoutStatement ? 'shootout-statement' : 'statement'),
				params: {
					id: JSON.stringify((JSON.parse(this.$route.params.id) + 1)),
					title: this.slugify(this.statementTitleToString(this.$store.getters.statement((JSON.parse(this.$route.params.id) + 1)).title))
				}
			})
		}
	}
	isSelectedButton(option: 'agree' | 'neither' | 'disagree' | 'skip'): boolean {
		const userChoices = this.isShootoutStatement ? this.user.shootoutChoices : this.user.choices
		const statementIndex = (JSON.parse(this.$route.params.id) - 1)

		if (!userChoices[statementIndex]) return false
		
		return userChoices[statementIndex].choice === option
	}
	toggleParty(partyIndex: string) {
		if (this.openParties.indexOf(partyIndex) !== -1) {
			this.openParties.splice(this.openParties.indexOf(partyIndex), 1)
		} else {
			this.openParties.push(partyIndex)
		}
	}
	loadAnalyticsToken() {
		if (process.env.NODE_ENV === 'production') {
			StemWijzerHTTP.get(this.config.settings.analytics.tokenUrl)
				.then((response) => {
					if (response.data) {
						this.$store.dispatch('setUserToken', response.data);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		} else {
			console.info('Running on dev, not loading token.');
		}
	}
	created() {

		if (this.$route.params.id === '1') {
			this.loadAnalyticsToken();
		}
		
		setTimeout(() => {
			this.disableChoicebuttons = false
		}, 150);
	}
	onMoreInfoClicked() {
		if (this.openTab === 'moreInfo') {
			this.openTab = false;
		} else {
			this.openTab = 'moreInfo';
			this.trackGAEvent('extra-moreInfo');
		}
	}
	onPartiesInfoClicked() {
		if (this.openTab === 'parties') {
			this.openTab = false;
		} else {
			this.openTab = 'parties';
			this.trackGAEvent('extra-parties');
		}
	}
}
